import React, { useEffect } from "react";
import { useProfileUpdate } from "@/hooks/useMembers";

export const ProfileUpdateListenerProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { updateMemberInLocalStorage } = useProfileUpdate();

  useEffect(() => {
    function handleMsg(ev: MessageEvent) {
      try {
        const msg = JSON.parse(ev.data);
        if (msg.type === "wipe_local_storage") {
          console.log("Wiping local storage for member:", msg.memberId);
          updateMemberInLocalStorage(msg.memberId);
        }
      } catch {
        /* noop -- malformed message payloads are ignored */
      }
    }
    window.addEventListener("message", handleMsg);
    return () => window.removeEventListener("message", handleMsg);
  }, [updateMemberInLocalStorage]);

  return <>{children}</>;
};
